"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addMetadataTabs = exports.MetadataOptions = exports.isSoeMetadataUrl = exports.MetadataSourceEnum = exports.defaultFormatterPage = void 0;
var tslib_1 = require("tslib");
var layer_metadata_soe_client_1 = require("@wsdot/layer-metadata-soe-client");
exports.defaultFormatterPage = "https://wsdot-gis.github.io/geospatial-metadata";
var MetadataSourceEnum;
(function (MetadataSourceEnum) {
    MetadataSourceEnum[MetadataSourceEnum["None"] = 0] = "None";
    MetadataSourceEnum[MetadataSourceEnum["BuiltIn"] = 1] = "BuiltIn";
    MetadataSourceEnum[MetadataSourceEnum["Soe"] = 2] = "Soe";
    MetadataSourceEnum[MetadataSourceEnum["Both"] = 3] = "Both"; // BuiltIn | Soe
})(MetadataSourceEnum = exports.MetadataSourceEnum || (exports.MetadataSourceEnum = {}));
/**
 * Detects if a metadata URL is a WSDOT custom LayerMetadata SOE URL.
 * @param url metadata URL
 * @returns Returns true if URL contains "exts/LayerMetadata", false otherwise.
 */
function isSoeMetadataUrl(url) {
    var re = /\bexts\/LayerMetadata\b/gi;
    return re.test(url instanceof URL ? url.href : url);
}
exports.isSoeMetadataUrl = isSoeMetadataUrl;
/**
 * Creates a URL for a page that formats a metadata URL's XML into HTML.
 * @param metadataUrl Metadata URL.
 * @param options Controls how the metadata will be formatted.
 * @returns output URL
 */
function wrapUrlWithFormatterPage(metadataUrl, options) {
    var formatterPageUrl = options.formatterPageUrl, format = options.format, output = options.output, whatToFormat = options.whatToFormat;
    var isSoe = isSoeMetadataUrl(metadataUrl);
    if (!(metadataUrl instanceof URL)) {
        metadataUrl = new URL(metadataUrl);
    }
    function shouldWrap() {
        if (!formatterPageUrl) {
            console.groupEnd();
            return false;
        }
        // Set whatToFormat to None if undefined.
        if (whatToFormat == null) {
            whatToFormat = MetadataSourceEnum.None;
        }
        var shouldWrap;
        if (isSoe) {
            shouldWrap = (whatToFormat & MetadataSourceEnum.Soe) === MetadataSourceEnum.Soe;
            ;
            console.debug("Current URL is an SOE. Should wrap? ".concat(shouldWrap));
        }
        else {
            shouldWrap = (whatToFormat & MetadataSourceEnum.BuiltIn) === MetadataSourceEnum.BuiltIn;
        }
        console.groupEnd();
        return shouldWrap;
    }
    var outUrl;
    if (shouldWrap() && formatterPageUrl) {
        outUrl = new URL(formatterPageUrl);
        var paramUrl = new URL(metadataUrl);
        if (!isSoe) {
            // For the wrapper page, the output will need to be XML, so remove "output" parameter
            paramUrl.searchParams.delete("output");
            if (format) {
                paramUrl.searchParams.set("format", format);
            }
        }
        else {
            paramUrl.searchParams.set("f", "xml");
        }
        outUrl.searchParams.set("url", paramUrl.href);
    }
    else { // Unwrapped
        outUrl = new URL(metadataUrl);
        if (!isSoe) {
            console.debug("is not an SOE");
            if (output) {
                outUrl.searchParams.set("output", output);
            }
            if (format) {
                outUrl.searchParams.set("format", format);
            }
        }
        else if (output !== "html") {
            outUrl.searchParams.set("f", "xml");
        }
    }
    console.groupEnd();
    return outUrl;
}
var MetadataOptions = /** @class */ (function () {
    /**
     * Creates a new instance
     * @param options options
     */
    function MetadataOptions(_a) {
        var format = _a.format, output = _a.output, formatterPageUrl = _a.formatterPageUrl, whatToFormat = _a.whatToFormat;
        this.format = format || "fgdc";
        this.output = output || "html";
        this.formatterPageUrl = formatterPageUrl || exports.defaultFormatterPage;
        this.whatToFormat = whatToFormat || MetadataSourceEnum.Soe;
    }
    MetadataOptions.prototype.wrapMetadataUrl = function (url) {
        return wrapUrlWithFormatterPage(url, this);
    };
    return MetadataOptions;
}());
exports.MetadataOptions = MetadataOptions;
/**
 * Adds a "load" event handler to a layer list. When the layer list has loaded,
 * A metadata tab will be added to each layers list item after its checkbox is
 * clicked for the first time.
 *
 * **Must be called before LayerList.startup()!**
 * @param layerList Layer List dijit
 * @param formatterPageUrl URL of formatter page.
 */
function addMetadataTabs(layerList, options) {
    if (options === void 0) { options = {
        format: "fgdc",
        output: "html",
        formatterPageUrl: exports.defaultFormatterPage,
        whatToFormat: MetadataSourceEnum.Soe
    }; }
    layerList.on("load", function (_a) {
        var target = _a.target;
        // Get the DOM node of the layer list
        var node = target;
        // Get the checkboxes for each layer.
        var checkboxes = node.querySelectorAll(".esriTitleContainer > input[type=checkbox]:not([data-sublayer-index])");
        function setupMetadataTab(checkbox) {
            if (!checkbox.dataset.layerIndex) {
                return;
            }
            var layerIndex = parseInt(checkbox.dataset.layerIndex, 10);
            var opLayer = layerList.layers[layerIndex];
            var tabContainer;
            try {
                tabContainer = getTabContainerFromCheckbox(checkbox);
            }
            catch (err) {
                // If its one of the sublayer checkboxes, a TypeError
                // with be thrown.
                if (!(err instanceof TypeError)) {
                    throw err;
                }
            }
            if (tabContainer) {
                addMetadataTab(tabContainer, opLayer, layerIndex, options);
            }
        }
        // Setup an event to occur the first time layer's checkbox is clicked.
        Array.from(checkboxes, function (cb) {
            if (cb.checked) {
                setupMetadataTab(cb);
            }
            else {
                cb.addEventListener("click", function (ev) {
                    // "this" is the checkbox that was clicked.
                    setupMetadataTab(this);
                }, {
                    once: true,
                    passive: true
                });
            }
        });
    });
}
exports.addMetadataTabs = addMetadataTabs;
/**
 * Gets the tab container for the layer corresponding to the given checkbox
 * @param checkbox A checkbox input element.
 */
function getTabContainerFromCheckbox(checkbox) {
    var tabContainer = checkbox.parentElement.parentElement
        .nextElementSibling;
    return tabContainer;
}
/**
 * Parses a metadata source name into its component parts: database, schema, and table,
 * returning a document fragment with a corresponding span element for each.
 * @param dataSourceName The name of a metadata source.
 * @returns Returns a DocumentFragment containing span elements corresponding to database,
 * schema, and table parts of the metadata source name. If name can't be parsed, a
 * Text node with the input string is instead returned.
 */
function createFCNameSpans(dataSourceName) {
    var nameRe = /^([^\.]+)\.([^\.]+)\.([^\.]+)$/i;
    var match = dataSourceName.match(nameRe);
    if (match) {
        // Get the parts of the table name.
        var _a = tslib_1.__read(match, 4), db = _a[1], schema = _a[2], table = _a[3];
        var dbSpan = document.createElement("span");
        var schemaSpan = document.createElement("span");
        var tableSpan = document.createElement("span");
        dbSpan.textContent = db;
        schemaSpan.textContent = schema;
        tableSpan.textContent = table;
        dbSpan.classList.add("metadata-source-name__db");
        schemaSpan.classList.add("metadata-source-name__schema");
        tableSpan.classList.add("metadata-source-name__table");
        var docFrag_1 = document.createDocumentFragment();
        [dbSpan, schemaSpan, tableSpan].forEach(function (s) {
            docFrag_1.appendChild(s);
        });
        return docFrag_1;
    }
    return document.createTextNode(dataSourceName);
}
/**
 * Detects if the current layer supports metadata.
 * @param layer an operational layer
 * @param metadataOptions Specify the metadata output format.
 * @returns Returns an object which has properties named after layer names and these properties' values are the metadata URLs.
 */
function getBuiltInMetadataUrls(layer, metadataOptions) {
    var _a;
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        function appendParameters(url) {
            if (format) {
                url.searchParams.set("format", format);
            }
            if (output) {
                if (!format) {
                    console.warn("Metadata \"output\" parameter has been set to \"".concat(output, "\", but no value was given for the corresponding \"format\" parameter."));
                }
                url.searchParams.set("output", output);
            }
        }
        var layerUrl, serviceRootRe, serviceRootMatch, format, output, metadataUrl, layersUrl, response, layerInfo, mdLinks, metadataUrls, metadataUrls_1, metadataUrls_1_1, _b, name_1, url;
        var _c, e_1, _d;
        return tslib_1.__generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    layerUrl = (_a = layer.layer) === null || _a === void 0 ? void 0 : _a.url;
                    if (!layerUrl) {
                        return [2 /*return*/, null];
                    }
                    serviceRootRe = /(?:(?:Map)|(?:Feature))Server(\/?)$/g;
                    serviceRootMatch = layerUrl.match(serviceRootRe);
                    format = metadataOptions.format, output = metadataOptions.output;
                    if (!serviceRootMatch) {
                        // Exit if not a supported URL type.
                        return [2 /*return*/, null];
                    }
                    else if (!serviceRootMatch[1]) {
                        // Append trailing slash to URL if not present.
                        layerUrl += "/";
                    }
                    metadataUrl = new URL("".concat(layerUrl, "info/metadata"));
                    appendParameters(metadataUrl);
                    layersUrl = new URL("".concat(layerUrl, "layers?f=json"));
                    return [4 /*yield*/, fetch(layersUrl)];
                case 1:
                    response = _e.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    layerInfo = _e.sent();
                    mdLinks = (_c = {},
                        _c["".concat(layer.title || "Service")] = metadataUrl.href,
                        _c);
                    metadataUrls = layerInfo.layers.filter(function (l) { return l.hasMetadata; }).map(function (l) {
                        var url = new URL("".concat(layerUrl).concat(l.id, "/metadata/"));
                        appendParameters(url);
                        return [l.name, url.href];
                    });
                    try {
                        for (metadataUrls_1 = tslib_1.__values(metadataUrls), metadataUrls_1_1 = metadataUrls_1.next(); !metadataUrls_1_1.done; metadataUrls_1_1 = metadataUrls_1.next()) {
                            _b = tslib_1.__read(metadataUrls_1_1.value, 2), name_1 = _b[0], url = _b[1];
                            mdLinks[name_1] = url;
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (metadataUrls_1_1 && !metadataUrls_1_1.done && (_d = metadataUrls_1.return)) _d.call(metadataUrls_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                    return [2 /*return*/, mdLinks];
            }
        });
    });
}
/**
 * Adds the metadata tab to a layer's tab container after checking to see
 * if the layer in question supports the LayerMetadata SOE.
 * @param tabContainer
 * @param operationalLayer
 * @param layerIndex
 * @param options
 */
function addMetadataTab(tabContainer, operationalLayer, layerIndex, options) {
    var _a;
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        function enumerateMetadataUrls(mdLinks) {
            var _a, _b, _i, key, url;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!mdLinks)
                            return [2 /*return*/];
                        _a = [];
                        for (_b in mdLinks)
                            _a.push(_b);
                        _i = 0;
                        _c.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3 /*break*/, 4];
                        key = _a[_i];
                        if (!Object.prototype.hasOwnProperty.call(mdLinks, key)) return [3 /*break*/, 3];
                        url = mdLinks[key];
                        return [4 /*yield*/, [key, url]];
                    case 2:
                        _c.sent();
                        _c.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/];
                }
            });
        }
        var format, mdLinks, mdLinkArray, url, soeMetadataSupported, tabId, listItem, tab, tabList, tabs, ul, name_2, mdUrl, a, li;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    // Exit early if there is no layer URL.
                    if (!((_a = operationalLayer === null || operationalLayer === void 0 ? void 0 : operationalLayer.layer) === null || _a === void 0 ? void 0 : _a.url)) {
                        return [2 /*return*/];
                    }
                    format = options.format;
                    return [4 /*yield*/, getBuiltInMetadataUrls(operationalLayer, options)];
                case 1:
                    mdLinks = _b.sent();
                    mdLinkArray = tslib_1.__spreadArray([], tslib_1.__read(enumerateMetadataUrls(mdLinks)), false);
                    if (!(mdLinkArray.length <= 1)) return [3 /*break*/, 4];
                    url = operationalLayer.layer.url;
                    return [4 /*yield*/, (0, layer_metadata_soe_client_1.detectLayerMetadataSupport)(url)];
                case 2:
                    soeMetadataSupported = _b.sent();
                    if (!soeMetadataSupported) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, (0, layer_metadata_soe_client_1.getMetadataLinks)(url)];
                case 3:
                    // Get metadata URLs.
                    mdLinks = _b.sent();
                    _b.label = 4;
                case 4:
                    tabId = "metadata";
                    listItem = document.createElement("li");
                    listItem.tabIndex = 0;
                    listItem.dataset.tabId = tabId;
                    listItem.dataset.layerIndex = layerIndex.toString(10);
                    listItem.setAttribute("role", "tab");
                    listItem.classList.add("esriTabMenuItem");
                    listItem.textContent = "Metadata";
                    tab = document.createElement("div");
                    tab.classList.add("esriTab", "metadata-panel");
                    tab.setAttribute("role", "tabpanel");
                    tab.dataset.tabId = tabId;
                    tabList = tabContainer.firstElementChild;
                    tabs = tabContainer.children[1];
                    tabList.appendChild(listItem);
                    tabs.appendChild(tab);
                    ul = document.createElement("ul");
                    ul.classList.add("layer-metadata-list");
                    for (name_2 in mdLinks) {
                        if (mdLinks.hasOwnProperty(name_2)) {
                            mdUrl = mdLinks[name_2];
                            a = document.createElement("a");
                            a.target = "wsdot-metadata";
                            a.href = wrapUrlWithFormatterPage(mdUrl, options).href;
                            a.appendChild(createFCNameSpans(name_2));
                            li = document.createElement("li");
                            li.appendChild(a);
                            ul.appendChild(li);
                        }
                    }
                    tab.appendChild(ul);
                    return [2 /*return*/];
            }
        });
    });
}
